// TODO: Use translation to prevent hard code
export const STRENGTHS = [{
  message: '密碼強度：強',
  color: '#4fbf40',
  type: 'strong',
}, {
  message: '密碼強度：好',
  color: '#4fbf40',
  type: 'medium',
}, {
  message: '密碼強度：弱',
  color: '#d0021b',
  type: 'weak',
}];
